{
  "page": {
    "title": "القوائم المرجعية",
    "subtitle": "العناصر الموقوفة تختفي من الاختيارات الجديدة وتبقى ظاهرة في السجلات السابقة"
  },
  "dialog": {
    "editTitle": "تعديل {{name}}",
    "addTitle": "إضافة عنصر"
  },
  "table": {
    "itemsCount": "{{n}} عنصراً",
    "addTo": "إضافة إلى {{name}}",
    "emptyTitle": "القائمة فارغة",
    "emptyHint": "أضف أول عنصر.",
    "activated": "تم تفعيل {{name}}",
    "deactivated": "تم إيقاف {{name}}",
    "activate": "تفعيل {{name}}",
    "deactivate": "إيقاف {{name}}",
    "edit": "تعديل {{name}}"
  },
  "columns": {
    "name": "الاسم",
    "english": "بالإنجليزية",
    "code": "الرمز",
    "order": "الترتيب",
    "active": "مفعّل"
  },
  "form": {
    "nameAr": "الاسم بالعربية",
    "nameEn": "الاسم بالإنجليزية",
    "nameEnHint": "اختياري — يُستخدم لتوليد رمز ثابت للعنصر",
    "order": "الترتيب",
    "orderHint": "الأصغر يظهر أولاً",
    "saving": "جاري الحفظ…",
    "saveChanges": "حفظ التعديلات",
    "add": "إضافة",
    "saved": "تم حفظ التعديلات",
    "added": "تمت الإضافة",
    "codeExists": "يوجد عنصر بنفس الاسم الإنجليزي في هذه القائمة",
    "saveFailed": "تعذر الحفظ"
  },
  "validation": {
    "nameArRequired": "الاسم بالعربية مطلوب",
    "max60": "الحد الأقصى 60 حرفاً",
    "sortOrder": "رقم من 0 إلى 999"
  }
}
